import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';




@Component({
  selector: 'app-prduct-thumb',
  templateUrl: './prduct-thumb.component.html',
  styleUrls: ['./prduct-thumb.component.scss'],
})
export class PrductThumbComponent implements OnInit {
  @Input() product: any;
  @Input() gridType: string;
  @Input() subscriptionFeature: boolean;
  @Input() showPrices: boolean;
  @Input() role: string;
  @Input() index: number;
  @Input() style: any;

  @Output() openPriceModalEvent = new EventEmitter<number>();
  @Output() addProductToCartEvent = new EventEmitter<number>();
  @Output() decrementQuantityEvent = new EventEmitter<number>();
  @Output() incrementQuantityEvent = new EventEmitter<number>();
  @Output() goToProductEvent = new EventEmitter<number>();
  @Output() heartClickedEvent = new EventEmitter<number>();
  @Output() deleteWishlistPdtEvent = new EventEmitter<number>();
  @Output() priceListFirstToCartEvent = new EventEmitter<number>();
  designStudioActive;

  
  constructor(private consoleService:ConsoleService,private designStudioService:DesignStudioService,) { }

  async ngOnInit() {
    this.designStudioActive = this.designStudioService.designStudioActive;
    this.consoleService.consoleLog('product-thumb designStudioActive',this.designStudioActive);
    if(!this.style || Object.keys(this.style).length === 0 || !this.designStudioActive){
      console.log('no style');
      this.style = await this.designStudioService.getSessionStorageGlobalData();
    }
    this.consoleService.consoleLog('prduct-thumb.component:54 style', this.style)
  }

  async openPriceModal() {
    this.openPriceModalEvent.emit(this.index);
  }

  async addProductToCart() {
    this.addProductToCartEvent.emit(this.index);
  }

  async decrementQuantity() {
    this.decrementQuantityEvent.emit(this.index);
  }
  async incrementQuantity() {
    this.incrementQuantityEvent.emit(this.index);
  }

  goToProduct() {
    this.goToProductEvent.emit(this.index);
  }

  async heartClicked() {
    this.heartClickedEvent.emit(this.index);
  }

  async deleteWishlistPdt() {
    this.deleteWishlistPdtEvent.emit(this.index);
  }

  priceListFirstToCart() {
    if (this.product.data.priceList[0].totalQuantity === '0') {
        this.openPriceModalEvent.emit(this.index);
    } else {
        this.priceListFirstToCartEvent.emit(this.index);
    }
}

}
